/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-22 15:47:49
 * @LastEditTime: 2020-10-22 15:48:02
 */
import i18n from "@/common/lang";
export const Columns = [
  { LabelName: i18n.t('lang.devicelist.SerialNumber'), row: 80, align: 'center', key: 0, ColumnsKey: 'Index', slot: true},
  { LabelName: '序列号', key: 1, ColumnsKey: 'deviceSn', seek: 'deviceSn', sort: 'custom', placeholder: '设备序列号'},
  { LabelName: '名称', key: 2, ColumnsKey: 'deviceName',seek: 'deviceName', placeholder: '设备名称', sort: 'custom'  },
  { LabelName: '所属一级项目', key: 3, ColumnsKey: 'firstLevelName' }, 
  { LabelName: '所属二级项目', key: 4, ColumnsKey: 'secondLevelName'},   
  { LabelName: i18n.t('lang.devicelist.statevoid'), align: 'center', key: 5, ColumnsKey: 'deviceIsconnected', Tag: true, placeholder: i18n.t('lang.devicelist.search5'), Fun: 'GetStatus'},
  { LabelName: 'IP地址', key: 6, ColumnsKey: 'deviceIp',seek: 'deviceIp', placeholder: i18n.t('lang.devicelist.search2')},
  { LabelName: '设备地址', key: 7, ColumnsKey: 'deviceAddress',seek: 'deviceAddress', placeholder: i18n.t('lang.devicelist.search2')},
]
